<sc-flex fitHeight stretchContent [gap]="16">

  <sc-flex-fitting-content>

    <sc-flex vertical fitHeight stretchContent [gap]="16">

      <sc-sub-title>
        <sc-dictionary-label
        dictionaryKey="tmc-yard.entity.transport-options-administration.constraint-option-assignment-editor.columns.configured"></sc-dictionary-label>
      </sc-sub-title>

      <sc-flex-fitting-content vertical>
        <div cdkDropList #availableList="cdkDropList" [cdkDropListData]="assignedOptions" cdkDropListSortingDisabled
          [cdkDropListConnectedTo]="[configuredList]" class="list" (cdkDropListDropped)="drop($event)">
          @for (item of assignedOptions; track item) {
            <div class="list-item-box" cdkDrag>
              <div class="list-item">
                {{ item | translateDictionaryEntry:[item.name, translationService.language]}}
              </div>
            </div>
          }
        </div>

      </sc-flex-fitting-content>

    </sc-flex>

  </sc-flex-fitting-content>

  <sc-flex-fitting-content>

    <sc-flex vertical fitHeight stretchContent [gap]="16">

      <sc-sub-title>
        <sc-dictionary-label
        dictionaryKey="tmc-yard.entity.transport-options-administration.constraint-option-assignment-editor.columns.available"></sc-dictionary-label>
      </sc-sub-title>

      <sc-flex-fitting-content vertical>

        <div cdkDropList #configuredList="cdkDropList" [cdkDropListData]="availableOptions" cdkDropListSortingDisabled
          [cdkDropListConnectedTo]="[availableList]" class="list" (cdkDropListDropped)="dropToAvailableList($event)">
          @for (item of availableOptions; track item) {
            <div class="list-item-box" cdkDrag>
              <div class="list-item">
                {{ item | translateDictionaryEntry:[item.name, translationService.language]}}
              </div>
            </div>
          }
        </div>

      </sc-flex-fitting-content>

    </sc-flex>

  </sc-flex-fitting-content>

<!-- </sc-flex>

<div class="constraint-option-assignment-editor">
  <div class="main-layout">
    <div class="column">
      <div class="column-layout">
        <div class="header-label">

        </div>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <div class="column">
        <div class="column-layout">
          <div class="header-label">

          </div>

        </div>
      </div>
    </div>
  </div> -->
